import { render, staticRenderFns } from "./DodAddUserForm.vue?vue&type=template&id=5541bfd1&scoped=true&"
import script from "./DodAddUserForm.vue?vue&type=script&lang=js&"
export * from "./DodAddUserForm.vue?vue&type=script&lang=js&"
import style0 from "./DodAddUserForm.vue?vue&type=style&index=0&id=5541bfd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5541bfd1",
  null
  
)

export default component.exports